module.exports = __webpack_public_path__ + "static/media/duggan-brothers.080c5946.png";